import { Typography } from "@mui/material";
import React, { FunctionComponent, useEffect } from "react";
import { setBackHandler } from "../../helpers/header.helper";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import * as selector from '../../selectors/selectors'

interface Props {
	HandleFile: (e: any) => void;
	FileToUpload: any;
	HasError: string;
	Header?: string;
	SubHeader?: string;
	Description?: React.ReactNode;
	Icon?: React.ReactNode;
	AllowDragDrop?: boolean;
	AllowFileTypes?: string;
}
const ImportFiles: FunctionComponent<Props> = (props: Props) => {
	const navigate = useNavigate();
	const IsDarkMode: boolean = useSelector(selector.isDarkMode)

	useEffect(() => {
		setBackHandler(() => navigate(-1));
	}, [])

	return (
		<div className="t-align-center"
			onDrop={(event) => {
				event.preventDefault()
				if (props.AllowDragDrop) {
					const files = Array.from(event.dataTransfer.items).map((item) => item.getAsFile() as File)
					files.forEach(async (file) => {
						if (file !== null) {
							props.HandleFile(file)
						}
					})
				}
			}}
			onDragOverCapture={(event) => {
				event.preventDefault();
			}}
			onPaste={(event) => {
				if (props.AllowDragDrop) {
					const files = Array.from(event.clipboardData.items).map((item) => item.getAsFile() as File)
					files.forEach(async (file) => {
						if (file !== null) {
							props.HandleFile(file)
						};
					})
				}
			}}>
			<Typography className="h3-regular color-import-contact-title color-conv-card-title">
				{props.Header}
			</Typography>
			<div className="justify-center p-2 align-center my-2">
				<label className="br-2 px-2 w-space c-pointer" htmlFor="Upload">
					{props.Icon}
				</label>
				<input
					id="Upload"
					type="file"
					className="d-flex t-0 l-0 opacity-0 c-pointer"
					onChange={props.HandleFile}
					accept={props.AllowFileTypes}
				/>
				<div className={`h4-regular ${props.FileToUpload ? 'color-primary-btn-focus' : 'color-disabled-btn'} ml-2`}>
					{props.FileToUpload ? props.FileToUpload.name : props.SubHeader}
				</div>
			</div>
			<Typography className={`h5-regular ${IsDarkMode ? "" : "color-disabled-btn"} `}>
				{props.Description}
			</Typography>
			<br />
			{!!props.HasError &&
				<Typography className="h5-regular color-primary-danger">
					{props.HasError}
				</Typography>
			}
		</div>
	);
}
export default ImportFiles;